import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import React, { useCallback } from 'react';
import classnames from 'classnames';
import { useDropzone } from 'react-dropzone';
import { useEditorContext } from '../../Editor/Context';
import s from './EditorDropzone.scss';
const defaultAcceptedFileTypes = {
    'image/*': []
};
const EditorDropzone = ({ children, className, classNameAccept, classNameReject, acceptedFileTypes: accept = defaultAcceptedFileTypes })=>{
    const editor = useEditorContext();
    const onDrop = useCallback((acceptedFiles)=>{
        if (acceptedFiles.length) {
            var _editor_commands;
            editor === null || editor === void 0 ? void 0 : (_editor_commands = editor.commands) === null || _editor_commands === void 0 ? void 0 : _editor_commands.daUploadFile(acceptedFiles[0]);
        }
    }, [
        editor === null || editor === void 0 ? void 0 : editor.commands
    ]);
    const { getRootProps, getInputProps, isDragActive, isDragAccept, isDragReject } = useDropzone({
        onDrop,
        accept,
        noClick: true
    });
    return /*#__PURE__*/ React.createElement("div", _object_spread_props(_object_spread({}, getRootProps()), {
        className: classnames(className, isDragAccept && s['accept-drop'], isDragAccept && classNameAccept, isDragReject && s['reject-drop'], isDragReject && classNameReject),
        "data-wrapper": "1"
    }), isDragActive && /*#__PURE__*/ React.createElement("input", getInputProps()), children);
};
EditorDropzone.displayName = 'EditorDropzone';
export default EditorDropzone;

//# sourceMappingURL=EditorDropzone.js.map